<template>
  <div class="bear-upload-dialog">
     <!-- :disabled="!isEdit || modelValue.length == maxLimit" -->
    <el-button type="primary" @click="uploadDialog">上传</el-button>
    <bear-file-list :file-list="modelValue" @del-file="delFile" :is-edit="isEdit"></bear-file-list>
    <el-dialog v-model="uploadDlgVisible" custom-class="dlg-upload" width="800px" :close-on-click-modal="false" append-to-body>
      <el-upload
        v-loading="loading"
        ref="upload"
        :accept="accept"
        :action="fileServer"
        :auto-upload="false"
        :multiple="true"
        :data="data"
        :on-change="handleChange"
        :on-success="success"
        :on-before="beforeUpload">
        <template #trigger>
          <el-button class="btn-upload-select" type="primary">选取文件</el-button>
        </template>
        <template #default>
          <el-button class="btn-upload-server" type="success" @click="submitUpload">上传到服务器</el-button>
        </template>
      </el-upload>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex"
import BearFileList from "../../file-list/src"
import { dateFormat } from '@/common/js/utils'

export default {
  name: "BearTrafficUploadDialog",
  components: {
    BearFileList,
  },
  props: {
    modelValue: {
      type: Array,
      default() {
        return [];
      },
    },
    accept: String,
    drag: Boolean,
    withCredentials: Boolean,
    maxLimit: {
      default: 999,
    },
  },
  computed: {
    ...mapState(["fileServer"]),
    ...mapGetters(["isEdit"]),
  },
  data() {
    return {
      uploadDlgVisible: false,
      loading: false,
      data: {
        name: "",
        chunk: 0,
        chunks: 1,
        key: "",
        token: "",
      },
    };
  },
  methods: {
    uploadDialog() {
      this.uploadDlgVisible = true;
    },
    handleFileSelect() {
      console.log("选择文件");
    },
    handleChange(file, uploadFiles) {
      this.setFileToken(file)
    },
    setFileToken(file) {
      let { data } = this;
      let { size, raw } = file;
      if (this.modelValue === null) {
        this.$emit("update:modelValue", []);
        this.$emit("input", []);
      }
      this.requestFileToken(raw).then((res) => {
        this.loading = false;
        let { uptoken } = res;
        let fileType = this.getFileType(raw)
        let guid = `${Date.now()}${fileType}${size}`;
        let key = `upload/${dateFormat('yyyyMM')}/${guid}.${fileType}`;
        data.name = raw.name;
        data.key = raw.key = key;
        data.token = raw.token = uptoken;
      }).catch((e) => {
        console.log('setFileToken', e)
        this.loading = false;
        this.$message.error("获取上传文件令牌失败！请联系客服");
      });
    },
    getFileType(file) {
      let { name } = file;
      let index = name.lastIndexOf(".");
      return name.slice(index + 1);
    },
    submitUpload() {
      this.loadign = true;
      this.$refs.upload.submit();
    },
    success(res, file, files) {
      this.loading = false;
      let fileType = this.getFileType(file)
      this.modelValue.push({
        FILETILE: file.name.replace(fileType, ''),
        FILETYPE: fileType,
        FILE_NAME: file.name,
        GUID: res.guid
      });
      this.$emit("update:modelValue", this.modelValue);
      this.$emit("input", res);
    },
    beforeUpload(file) {
      this.loading = true;
      this.data.key = file.key;
      this.data.token = file.token;
    },
    delFile(i) {
      this.modelValue.splice(i, 1);
      if (this.maxLimit == 1) {
        this.$emit("input", false);
      } else {
        this.$emit("update:modelValue", this.modelValue);
        this.$emit("input");
      }
    },
    ...mapActions(["requestFileToken"]),
  },
};
</script>
<style lang="scss" scoped>
.btn-upload-select,
.btn-upload-server {
  margin-right: 10px;
}
</style>
<style lang="scss">
.tender-form-item {
  .is-error {
    .bear-upload-dialog {
      .el-button--primary {
        background: red;
        border: 1px solid red;
      }
      .el-form-item__error {
        display: none;
      }
    }
  }
}
</style>
